import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export default function Header() {
  return (
    <Table.Head>
      <Table.Row>
        {[
          i18n.t('surveys.form.participants.table.header.name'),
          i18n.t('surveys.form.participants.table.header.office'),
        ].map((str) => (
          <Table.HeadCell key={str}>{str}</Table.HeadCell>
        ))}
        <Table.HeadCell />
      </Table.Row>
    </Table.Head>
  )
}
